import * as React from 'react';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import { NextButtonProps } from '@interfaces/wizard/wizard';

const NextButton: React.FunctionComponent<NextButtonProps> = (props): React.ReactElement => {
  const { children, isSubmitting, nextText, isLoading, handleNext } = props;
  if (children) {
    return children({ ...props });
  }
  return (
    <Button
      type={BUTTON_TYPES.PRIMARY}
      text={nextText || 'Next'}
      isLoading={isSubmitting || isLoading}
      onClick={handleNext}
      {...props}
    />
  );
};

export default NextButton;
